/* Copyright © 2017-2025 Kuali, Inc. - All Rights Reserved */
// THIS IS A GENERATED FILE. PLEASE DO NOT EDIT DIRECTLY
// See https://docs.kualibuild.ninja/scripts/import-icons for instructions on how to re-generate this file
import cx from 'clsx'

import { ReactComponent as ActionsIcon } from './raw/actions.svg.jsx'
import { ReactComponent as AddIcon } from './raw/add.svg.jsx'
import { ReactComponent as AdminApproveIcon } from './raw/admin-approve.svg.jsx'
import { ReactComponent as AlertErrorIcon } from './raw/alert-error.svg.jsx'
import { ReactComponent as AlertHelpIcon } from './raw/alert-help.svg.jsx'
import { ReactComponent as AlertInfoIcon } from './raw/alert-info.svg.jsx'
import { ReactComponent as AlertWarningIcon } from './raw/alert-warning.svg.jsx'
import { ReactComponent as AnalyticsIcon } from './raw/analytics.svg.jsx'
import { ReactComponent as AnchorIcon } from './raw/anchor.svg.jsx'
import { ReactComponent as AppSwitcherIcon } from './raw/app-switcher.svg.jsx'
import { ReactComponent as AppWindowIcon } from './raw/app-window.svg.jsx'
import { ReactComponent as ArchiveIcon } from './raw/archive.svg.jsx'
import { ReactComponent as AscendingAlphabeticalIcon } from './raw/ascending-alphabetical.svg.jsx'
import { ReactComponent as AssociationsIcon } from './raw/associations.svg.jsx'
import { ReactComponent as AttachmentIcon } from './raw/attachment.svg.jsx'
import { ReactComponent as AwardIcon } from './raw/award.svg.jsx'
import { ReactComponent as BackIcon } from './raw/back.svg.jsx'
import { ReactComponent as BadgeIcon } from './raw/badge.svg.jsx'
import { ReactComponent as BoldIcon } from './raw/bold.svg.jsx'
import { ReactComponent as BookIcon } from './raw/book.svg.jsx'
import { ReactComponent as BookmarkIcon } from './raw/bookmark.svg.jsx'
import { ReactComponent as BranchIcon } from './raw/branch.svg.jsx'
import { ReactComponent as BrandsettingsIcon } from './raw/brandsettings.svg.jsx'
import { ReactComponent as BrokenLinkIcon } from './raw/broken-link.svg.jsx'
import { ReactComponent as BulletListIcon } from './raw/bullet-list.svg.jsx'
import { ReactComponent as BusinessCardIcon } from './raw/business-card.svg.jsx'
import { ReactComponent as CalculateIcon } from './raw/calculate.svg.jsx'
import { ReactComponent as CameraIcon } from './raw/camera.svg.jsx'
import { ReactComponent as CenterAlignIcon } from './raw/center-align.svg.jsx'
import { ReactComponent as ChatIcon } from './raw/chat.svg.jsx'
import { ReactComponent as CheckCircleIcon } from './raw/check-circle.svg.jsx'
import { ReactComponent as CheckIcon } from './raw/check.svg.jsx'
import { ReactComponent as ClearTextFormatIcon } from './raw/clear-text-format.svg.jsx'
import { ReactComponent as ClipboardIcon } from './raw/clipboard.svg.jsx'
import { ReactComponent as CloseIcon } from './raw/close.svg.jsx'
import { ReactComponent as CloudIcon } from './raw/cloud.svg.jsx'
import { ReactComponent as CollapsedIcon } from './raw/collapsed.svg.jsx'
import { ReactComponent as ComputerIcon } from './raw/computer.svg.jsx'
import { ReactComponent as ConfigurationIcon } from './raw/configuration.svg.jsx'
import { ReactComponent as CowboyHatIcon } from './raw/cowboy-hat.svg.jsx'
import { ReactComponent as CursorIcon } from './raw/cursor.svg.jsx'
import { ReactComponent as DashboardIcon } from './raw/dashboard.svg.jsx'
import { ReactComponent as DateIcon } from './raw/date.svg.jsx'
import { ReactComponent as DeleteColumnIcon } from './raw/delete-column.svg.jsx'
import { ReactComponent as DeleteRowIcon } from './raw/delete-row.svg.jsx'
import { ReactComponent as DeleteTableIcon } from './raw/delete-table.svg.jsx'
import { ReactComponent as DeleteIcon } from './raw/delete.svg.jsx'
import { ReactComponent as DenyOverrideIcon } from './raw/deny-override.svg.jsx'
import { ReactComponent as DescendingAlphabeticalIcon } from './raw/descending-alphabetical.svg.jsx'
import { ReactComponent as DislikeIcon } from './raw/dislike.svg.jsx'
import { ReactComponent as DownloadIcon } from './raw/download.svg.jsx'
import { ReactComponent as DragSortIcon } from './raw/drag-sort.svg.jsx'
import { ReactComponent as DragIcon } from './raw/drag.svg.jsx'
import { ReactComponent as DuplicateIcon } from './raw/duplicate.svg.jsx'
import { ReactComponent as EchoIcon } from './raw/echo.svg.jsx'
import { ReactComponent as EditAppIcon } from './raw/edit-app.svg.jsx'
import { ReactComponent as EditDocIcon } from './raw/edit-doc.svg.jsx'
import { ReactComponent as EditIcon } from './raw/edit.svg.jsx'
import { ReactComponent as EmailIcon } from './raw/email.svg.jsx'
import { ReactComponent as EmojiHappyIcon } from './raw/emoji-happy.svg.jsx'
import { ReactComponent as EmojiMehIcon } from './raw/emoji-meh.svg.jsx'
import { ReactComponent as EmojiSadIcon } from './raw/emoji-sad.svg.jsx'
import { ReactComponent as ExpandedIcon } from './raw/expanded.svg.jsx'
import { ReactComponent as ExportAllIcon } from './raw/export-all.svg.jsx'
import { ReactComponent as ExportViewIcon } from './raw/export-view.svg.jsx'
import { ReactComponent as ExportIcon } from './raw/export.svg.jsx'
import { ReactComponent as FavoriteFilledIcon } from './raw/favorite-filled.svg.jsx'
import { ReactComponent as FavoriteIcon } from './raw/favorite.svg.jsx'
import { ReactComponent as FileImageIcon } from './raw/file-image.svg.jsx'
import { ReactComponent as FilterIcon } from './raw/filter.svg.jsx'
import { ReactComponent as FingerPointingIcon } from './raw/finger-pointing.svg.jsx'
import { ReactComponent as FlagIcon } from './raw/flag.svg.jsx'
import { ReactComponent as FolderOpenIcon } from './raw/folder-open.svg.jsx'
import { ReactComponent as FolderIcon } from './raw/folder.svg.jsx'
import { ReactComponent as FontSizeIcon } from './raw/font-size.svg.jsx'
import { ReactComponent as GenericFileIcon } from './raw/generic-file.svg.jsx'
import { ReactComponent as HiddenIcon } from './raw/hidden.svg.jsx'
import { ReactComponent as HistoryIcon } from './raw/history.svg.jsx'
import { ReactComponent as HomeIcon } from './raw/home.svg.jsx'
import { ReactComponent as HourglassIcon } from './raw/hourglass.svg.jsx'
import { ReactComponent as HtmlSelectIcon } from './raw/html-select.svg.jsx'
import { ReactComponent as InsertAboveIcon } from './raw/insert-above.svg.jsx'
import { ReactComponent as InsertBelowIcon } from './raw/insert-below.svg.jsx'
import { ReactComponent as InsertHeaderIcon } from './raw/insert-header.svg.jsx'
import { ReactComponent as InsertLeftIcon } from './raw/insert-left.svg.jsx'
import { ReactComponent as InsertRightIcon } from './raw/insert-right.svg.jsx'
import { ReactComponent as InsightCountIcon } from './raw/insight-count.svg.jsx'
import { ReactComponent as InsightPastryIcon } from './raw/insight-pastry.svg.jsx'
import { ReactComponent as InsightRankIcon } from './raw/insight-rank.svg.jsx'
import { ReactComponent as InsightTableIcon } from './raw/insight-table.svg.jsx'
import { ReactComponent as InstitutionIcon } from './raw/institution.svg.jsx'
import { ReactComponent as IntegrationsIcon } from './raw/integrations.svg.jsx'
import { ReactComponent as ItalicIcon } from './raw/italic.svg.jsx'
import { ReactComponent as KeyIcon } from './raw/key.svg.jsx'
import { ReactComponent as KeyboardArrowDownIcon } from './raw/keyboard-arrow-down.svg.jsx'
import { ReactComponent as KualiKIcon } from './raw/kuali-k.svg.jsx'
import { ReactComponent as LeftAlignIcon } from './raw/left-align.svg.jsx'
import { ReactComponent as LikeIcon } from './raw/like.svg.jsx'
import { ReactComponent as LinkIcon } from './raw/link.svg.jsx'
import { ReactComponent as LocationIcon } from './raw/location.svg.jsx'
import { ReactComponent as LockIcon } from './raw/lock.svg.jsx'
import { ReactComponent as LoginIcon } from './raw/login.svg.jsx'
import { ReactComponent as LogoutIcon } from './raw/logout.svg.jsx'
import { ReactComponent as MapIcon } from './raw/map.svg.jsx'
import { ReactComponent as MaximizeIcon } from './raw/maximize.svg.jsx'
import { ReactComponent as MenuVerticalIcon } from './raw/menu-vertical.svg.jsx'
import { ReactComponent as MenuIcon } from './raw/menu.svg.jsx'
import { ReactComponent as MessageIcon } from './raw/message.svg.jsx'
import { ReactComponent as MinimizeIcon } from './raw/minimize.svg.jsx'
import { ReactComponent as MobileIcon } from './raw/mobile.svg.jsx'
import { ReactComponent as ModuleIcon } from './raw/module.svg.jsx'
import { ReactComponent as MoneyIcon } from './raw/money.svg.jsx'
import { ReactComponent as MoonIcon } from './raw/moon.svg.jsx'
import { ReactComponent as MoveLeftIcon } from './raw/move-left.svg.jsx'
import { ReactComponent as MoveRightIcon } from './raw/move-right.svg.jsx'
import { ReactComponent as MoveIcon } from './raw/move.svg.jsx'
import { ReactComponent as NewsIcon } from './raw/news.svg.jsx'
import { ReactComponent as NotificationOffIcon } from './raw/notification-off.svg.jsx'
import { ReactComponent as NotificationRingIcon } from './raw/notification-ring.svg.jsx'
import { ReactComponent as NotificationIcon } from './raw/notification.svg.jsx'
import { ReactComponent as NumberListIcon } from './raw/number-list.svg.jsx'
import { ReactComponent as PenDrawIcon } from './raw/pen-draw.svg.jsx'
import { ReactComponent as PhotosIcon } from './raw/photos.svg.jsx'
import { ReactComponent as PinIcon } from './raw/pin.svg.jsx'
import { ReactComponent as PlayIcon } from './raw/play.svg.jsx'
import { ReactComponent as PointIcon } from './raw/point.svg.jsx'
import { ReactComponent as PrintIcon } from './raw/print.svg.jsx'
import { ReactComponent as ProfileIcon } from './raw/profile.svg.jsx'
import { ReactComponent as RatingEmptyIcon } from './raw/rating-empty.svg.jsx'
import { ReactComponent as RatingFilledIcon } from './raw/rating-filled.svg.jsx'
import { ReactComponent as RatingHalfFilledIcon } from './raw/rating-half-filled.svg.jsx'
import { ReactComponent as RedoIcon } from './raw/redo.svg.jsx'
import { ReactComponent as RemoveHeaderIcon } from './raw/remove-header.svg.jsx'
import { ReactComponent as RemoveIcon } from './raw/remove.svg.jsx'
import { ReactComponent as ReportIcon } from './raw/report.svg.jsx'
import { ReactComponent as RevisionIcon } from './raw/revision.svg.jsx'
import { ReactComponent as RichTextIcon } from './raw/rich-text.svg.jsx'
import { ReactComponent as SearchIcon } from './raw/search.svg.jsx'
import { ReactComponent as SelectDownArrowIcon } from './raw/select-down-arrow.svg.jsx'
import { ReactComponent as SelectUpArrowIcon } from './raw/select-up-arrow.svg.jsx'
import { ReactComponent as SendEmailIcon } from './raw/send-email.svg.jsx'
import { ReactComponent as SendbackOverrideIcon } from './raw/sendback-override.svg.jsx'
import { ReactComponent as SendbackIcon } from './raw/sendback.svg.jsx'
import { ReactComponent as SettingsIcon } from './raw/settings.svg.jsx'
import { ReactComponent as ShareIcon } from './raw/share.svg.jsx'
import { ReactComponent as SortIcon } from './raw/sort.svg.jsx'
import { ReactComponent as StarsIcon } from './raw/stars.svg.jsx'
import { ReactComponent as StatusIcon } from './raw/status.svg.jsx'
import { ReactComponent as SunIcon } from './raw/sun.svg.jsx'
import { ReactComponent as SupportIcon } from './raw/support.svg.jsx'
import { ReactComponent as SyncTimeIcon } from './raw/sync-time.svg.jsx'
import { ReactComponent as SyncIcon } from './raw/sync.svg.jsx'
import { ReactComponent as TableIcon } from './raw/table.svg.jsx'
import { ReactComponent as TagIcon } from './raw/tag.svg.jsx'
import { ReactComponent as TargetIcon } from './raw/target.svg.jsx'
import { ReactComponent as TimeIcon } from './raw/time.svg.jsx'
import { ReactComponent as ToolIcon } from './raw/tool.svg.jsx'
import { ReactComponent as UndoIcon } from './raw/undo.svg.jsx'
import { ReactComponent as UnlockIcon } from './raw/unlock.svg.jsx'
import { ReactComponent as UserInfoIcon } from './raw/user-info.svg.jsx'
import { ReactComponent as UserIcon } from './raw/user.svg.jsx'
import { ReactComponent as UsersIcon } from './raw/users.svg.jsx'
import { ReactComponent as VisibleIcon } from './raw/visible.svg.jsx'
import { ReactComponent as WorkflowBackIcon } from './raw/workflow-back.svg.jsx'
import { ReactComponent as WorkflowCheckIcon } from './raw/workflow-check.svg.jsx'
import { ReactComponent as WorkflowCompleteIcon } from './raw/workflow-complete.svg.jsx'
import { ReactComponent as WorkflowErrorIcon } from './raw/workflow-error.svg.jsx'
import { ReactComponent as WorkflowNotifiedIcon } from './raw/workflow-notified.svg.jsx'
import { ReactComponent as WorkflowReassignedIcon } from './raw/workflow-reassigned.svg.jsx'
import { ReactComponent as WorkflowRetryIcon } from './raw/workflow-retry.svg.jsx'
import { ReactComponent as WorkflowSkippedIcon } from './raw/workflow-skipped.svg.jsx'
import { ReactComponent as WorkflowXIcon } from './raw/workflow-x.svg.jsx'
import { ReactComponent as ZoomInIcon } from './raw/zoom-in.svg.jsx'
import { ReactComponent as ZoomOutIcon } from './raw/zoom-out.svg.jsx'

type SvgProps = React.SVGProps<SVGSVGElement>

function build (Component: React.ComponentType<SvgProps>) {
  return function Icon ({ className, ...props }: SvgProps) {
    return (
      <Component
        aria-hidden={!props['aria-label']}
        className={cx('shrink-0', className)}
        fill='var(--svg-base)'
        {...props}
      />
    )
  }
}

export const Actions = build(ActionsIcon)
export const Add = build(AddIcon)
export const AdminApprove = build(AdminApproveIcon)
export const AlertError = build(AlertErrorIcon)
export const AlertHelp = build(AlertHelpIcon)
export const AlertInfo = build(AlertInfoIcon)
export const AlertWarning = build(AlertWarningIcon)
export const Analytics = build(AnalyticsIcon)
export const Anchor = build(AnchorIcon)
export const AppSwitcher = build(AppSwitcherIcon)
export const AppWindow = build(AppWindowIcon)
export const Archive = build(ArchiveIcon)
export const AscendingAlphabetical = build(AscendingAlphabeticalIcon)
export const Associations = build(AssociationsIcon)
export const Attachment = build(AttachmentIcon)
export const Award = build(AwardIcon)
export const Back = build(BackIcon)
export const Badge = build(BadgeIcon)
export const Bold = build(BoldIcon)
export const Book = build(BookIcon)
export const Bookmark = build(BookmarkIcon)
export const Branch = build(BranchIcon)
export const Brandsettings = build(BrandsettingsIcon)
export const BrokenLink = build(BrokenLinkIcon)
export const BulletList = build(BulletListIcon)
export const BusinessCard = build(BusinessCardIcon)
export const Calculate = build(CalculateIcon)
export const Camera = build(CameraIcon)
export const CenterAlign = build(CenterAlignIcon)
export const Chat = build(ChatIcon)
export const CheckCircle = build(CheckCircleIcon)
export const Check = build(CheckIcon)
export const ClearTextFormat = build(ClearTextFormatIcon)
export const Clipboard = build(ClipboardIcon)
export const Close = build(CloseIcon)
export const Cloud = build(CloudIcon)
export const Collapsed = build(CollapsedIcon)
export const Computer = build(ComputerIcon)
export const Configuration = build(ConfigurationIcon)
export const CowboyHat = build(CowboyHatIcon)
export const Cursor = build(CursorIcon)
export const Dashboard = build(DashboardIcon)
export const Date = build(DateIcon)
export const DeleteColumn = build(DeleteColumnIcon)
export const DeleteRow = build(DeleteRowIcon)
export const DeleteTable = build(DeleteTableIcon)
export const Delete = build(DeleteIcon)
export const DenyOverride = build(DenyOverrideIcon)
export const DescendingAlphabetical = build(DescendingAlphabeticalIcon)
export const Dislike = build(DislikeIcon)
export const Download = build(DownloadIcon)
export const DragSort = build(DragSortIcon)
export const Drag = build(DragIcon)
export const Duplicate = build(DuplicateIcon)
export const Echo = build(EchoIcon)
export const EditApp = build(EditAppIcon)
export const EditDoc = build(EditDocIcon)
export const Edit = build(EditIcon)
export const Email = build(EmailIcon)
export const EmojiHappy = build(EmojiHappyIcon)
export const EmojiMeh = build(EmojiMehIcon)
export const EmojiSad = build(EmojiSadIcon)
export const Expanded = build(ExpandedIcon)
export const ExportAll = build(ExportAllIcon)
export const ExportView = build(ExportViewIcon)
export const Export = build(ExportIcon)
export const FavoriteFilled = build(FavoriteFilledIcon)
export const Favorite = build(FavoriteIcon)
export const FileImage = build(FileImageIcon)
export const Filter = build(FilterIcon)
export const FingerPointing = build(FingerPointingIcon)
export const Flag = build(FlagIcon)
export const FolderOpen = build(FolderOpenIcon)
export const Folder = build(FolderIcon)
export const FontSize = build(FontSizeIcon)
export const GenericFile = build(GenericFileIcon)
export const Hidden = build(HiddenIcon)
export const History = build(HistoryIcon)
export const Home = build(HomeIcon)
export const Hourglass = build(HourglassIcon)
export const HtmlSelect = build(HtmlSelectIcon)
export const InsertAbove = build(InsertAboveIcon)
export const InsertBelow = build(InsertBelowIcon)
export const InsertHeader = build(InsertHeaderIcon)
export const InsertLeft = build(InsertLeftIcon)
export const InsertRight = build(InsertRightIcon)
export const InsightCount = build(InsightCountIcon)
export const InsightPastry = build(InsightPastryIcon)
export const InsightRank = build(InsightRankIcon)
export const InsightTable = build(InsightTableIcon)
export const Institution = build(InstitutionIcon)
export const Integrations = build(IntegrationsIcon)
export const Italic = build(ItalicIcon)
export const Key = build(KeyIcon)
export const KeyboardArrowDown = build(KeyboardArrowDownIcon)
export const KualiK = build(KualiKIcon)
export const LeftAlign = build(LeftAlignIcon)
export const Like = build(LikeIcon)
export const Link = build(LinkIcon)
export const Location = build(LocationIcon)
export const Lock = build(LockIcon)
export const Login = build(LoginIcon)
export const Logout = build(LogoutIcon)
export const Map = build(MapIcon)
export const Maximize = build(MaximizeIcon)
export const MenuVertical = build(MenuVerticalIcon)
export const Menu = build(MenuIcon)
export const Message = build(MessageIcon)
export const Minimize = build(MinimizeIcon)
export const Mobile = build(MobileIcon)
export const Module = build(ModuleIcon)
export const Money = build(MoneyIcon)
export const Moon = build(MoonIcon)
export const MoveLeft = build(MoveLeftIcon)
export const MoveRight = build(MoveRightIcon)
export const Move = build(MoveIcon)
export const News = build(NewsIcon)
export const NotificationOff = build(NotificationOffIcon)
export const NotificationRing = build(NotificationRingIcon)
export const Notification = build(NotificationIcon)
export const NumberList = build(NumberListIcon)
export const PenDraw = build(PenDrawIcon)
export const Photos = build(PhotosIcon)
export const Pin = build(PinIcon)
export const Play = build(PlayIcon)
export const Point = build(PointIcon)
export const Print = build(PrintIcon)
export const Profile = build(ProfileIcon)
export const RatingEmpty = build(RatingEmptyIcon)
export const RatingFilled = build(RatingFilledIcon)
export const RatingHalfFilled = build(RatingHalfFilledIcon)
export const Redo = build(RedoIcon)
export const RemoveHeader = build(RemoveHeaderIcon)
export const Remove = build(RemoveIcon)
export const Report = build(ReportIcon)
export const Revision = build(RevisionIcon)
export const RichText = build(RichTextIcon)
export const Search = build(SearchIcon)
export const SelectDownArrow = build(SelectDownArrowIcon)
export const SelectUpArrow = build(SelectUpArrowIcon)
export const SendEmail = build(SendEmailIcon)
export const SendbackOverride = build(SendbackOverrideIcon)
export const Sendback = build(SendbackIcon)
export const Settings = build(SettingsIcon)
export const Share = build(ShareIcon)
export const Sort = build(SortIcon)
export const Stars = build(StarsIcon)
export const Status = build(StatusIcon)
export const Sun = build(SunIcon)
export const Support = build(SupportIcon)
export const SyncTime = build(SyncTimeIcon)
export const Sync = build(SyncIcon)
export const Table = build(TableIcon)
export const Tag = build(TagIcon)
export const Target = build(TargetIcon)
export const Time = build(TimeIcon)
export const Tool = build(ToolIcon)
export const Undo = build(UndoIcon)
export const Unlock = build(UnlockIcon)
export const UserInfo = build(UserInfoIcon)
export const User = build(UserIcon)
export const Users = build(UsersIcon)
export const Visible = build(VisibleIcon)
export const WorkflowBack = build(WorkflowBackIcon)
export const WorkflowCheck = build(WorkflowCheckIcon)
export const WorkflowComplete = build(WorkflowCompleteIcon)
export const WorkflowError = build(WorkflowErrorIcon)
export const WorkflowNotified = build(WorkflowNotifiedIcon)
export const WorkflowReassigned = build(WorkflowReassignedIcon)
export const WorkflowRetry = build(WorkflowRetryIcon)
export const WorkflowSkipped = build(WorkflowSkippedIcon)
export const WorkflowX = build(WorkflowXIcon)
export const ZoomIn = build(ZoomInIcon)
export const ZoomOut = build(ZoomOutIcon)
